module.exports = __webpack_public_path__ + "img/Flag_of_Jordan.9bc0dadc.svg";